export default class WebhookType {
  id: string;

  description: string;

  eventType: string;

  methodType: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id;
    this.description = obj.description;
    this.eventType = obj.eventType;
    this.methodType = obj.methodType;
    this.name = obj.name;
  }
}
